<template lang="pug">
  main.contacts(v-if="settings")
    header.header
      main-menu
      carousel(
        :perPage="1"
        :autoplay="true"
        :autoplayHoverPause="true"
        :loop="true"
        :autoplayTimeout="6000"
        paginationColor="#f8f8f8"
        paginationActiveColor="#5477a3"
      )
        slide(
          v-for="(slide, index) in settings.sections.contacts.carousel"
          :key="index"
          :style="`background-image:url(${slide})`"
        )
    section.section
      div.intro.container
        div.contatti
          h1 MAOS GROUP
          h4 {{ settings.sections.contacts.subtitle }}
          ul
            li {{ settings.sections.contacts.location.address }}
            li {{ settings.sections.contacts.location.phone }}
          div.administrative-contacts(v-for="item in settings.sections.contacts.administrative")
            h1 {{ item.title }}:
            ul
              li.name(v-for="people in item.people") {{ people.name }}
              li
                a(:href="`mailto:${settings.sections.contacts.admin.email}`" target="new") {{ settings.sections.contacts.admin.email }}
        div.referenti
          div(v-for="item in settings.sections.contacts.referents")
            h4 {{ item.title }}
            ul(v-for="people in item.people")
              li {{ people.name }}
              li
                a(:href="`mailto:${people.email}`" target="new") {{ people.email }}
                  span  // {{ people.tel }}
      div.map
        v-map(
          ref="map"
          :zoom="zoom"
          :center="center"
          :options="options"
        )
          v-tilelayer(
            :url="url"
          )
          v-geojson-layer(
            :geojson="geojson"
            :options="markers_options"
          )
</template>

<script>
import MainMenu from '@/components/MainMenu.vue'
import { mapState } from 'vuex'
import L from 'leaflet'
import Vue2Leaflet from 'vue2-leaflet'
import { Carousel, Slide } from 'vue-carousel'

const MARKERICON = function () {
  return L.divIcon({
    iconSize: [20, 20],
    iconAnchor: [0, 0],
    shadowSize: [0, 0],
    className: 'marker-contact'
  })
}

export default {
  name: 'contacts',
  metaInfo: {
    title: 'Contacts'
  },
  components: {
    'main-menu': MainMenu,
    'v-map': Vue2Leaflet.Map,
    'v-tilelayer': Vue2Leaflet.TileLayer,
    'v-geojson-layer': Vue2Leaflet.GeoJSON,
    Carousel,
    Slide
  },
  computed: mapState([
    'settings'
  ]),
  data () {
    return {
      url: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
      zoom: 12,
      center: [45.7674236, 13.741648],
      options: {
        dragging: true,
        scrollWheelZoom: false,
        zoomControl: false
      },
      geojson: {
        'type': 'FeatureCollection',
        'features': [
          {
            'type': 'Feature',
            'properties': {
              'title': 'OGS'
            },
            'geometry': {
              'type': 'Point',
              'coordinates': [
                13.7626238,
                45.7106708
              ]
            }
          }
        ]
      },
      markers_options: {
        pointToLayer: function (feature, latlng) {
          return L.marker(latlng, {icon: MARKERICON()})
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
a {
  font-size: 14px;
  color: #4a7d9f;
}
</style>



// WEBPACK FOOTER //
// src/views/Contacts.vue